import { useMemo } from 'react'

import { useApiRequest } from '@tabeeb/shared/utils/hooks'

import { type AIModelAIObjectResponse } from '@tabeeb/contracts/microservices/swagger-ai-service'
import { getAiModelAiObjects } from '../actions'

interface UseAIModelAIObjectsHookProps {
  id: number
  onError: (error: unknown) => void
}

interface UseAIModelAIObjectsHookState {
  loading: boolean
  aiObjects: AIModelAIObjectResponse[] | null
  abortRequest: () => void
}

export default ({ id, onError }: UseAIModelAIObjectsHookProps): UseAIModelAIObjectsHookState => {
  const payload = useMemo(() => ({ aiModelId: id }), [id])

  const {
    loading,
    response: aiObjects,
    abortRequest,
  } = useApiRequest({ request: getAiModelAiObjects.request, payload, onError })

  return { loading, aiObjects, abortRequest }
}
